import { Controller } from "@hotwired/stimulus";
import Panzoom from "@panzoom/panzoom";

export default class extends Controller {
  static targets = ["viewport", "content", "toolbar"];

  connect() {
    this.panzoom = null;
    this.initPanzoom();
    this.bindToolbar();
  }

  disconnect() {
    if (this.panzoom) {
      this.panzoom.destroy();
    }
  }

  initPanzoom() {
    const content = this.contentTarget;
    const viewport = this.viewportTarget;

    this.panzoom = Panzoom(content, {
      maxScale: 4,
      minScale: 1,
      cursor: "default",
      panOnlyWhenZoomed: true,
      touchAction: "pan-y",
    });

    content.addEventListener("panzoomchange", (e) => this.onPanzoomChange(e.detail));
    this.updateScrollBehavior(1);

    viewport.addEventListener("wheel", (e) => {
      e.preventDefault();
      this.panzoom.zoomWithWheel(e);
    });
  }

  onPanzoomChange(detail) {
    this.updateScrollBehavior(detail.scale);
  }

  updateScrollBehavior(scale) {
    const viewport = this.viewportTarget;
    const isZoomed = scale > 1;
    viewport.classList.toggle("touch-none", isZoomed);
    viewport.classList.toggle("cursor-grab", isZoomed);
    viewport.classList.toggle("cursor-default", !isZoomed);
    viewport.style.touchAction = isZoomed ? "none" : "pan-y";
    if (this.panzoom) {
      this.panzoom.setOptions({ cursor: isZoomed ? "grab" : "default", touchAction: isZoomed ? "none" : "pan-y" });
    }
  }

  bindToolbar() {
    if (!this.hasToolbarTarget) return;

    const zoomIn = this.toolbarTarget.querySelector("[data-zoom-action=zoom-in]");
    const zoomOut = this.toolbarTarget.querySelector("[data-zoom-action=zoom-out]");
    const reset = this.toolbarTarget.querySelector("[data-zoom-action=zoom-reset]");

    zoomIn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.zoomIn();
    });
    zoomOut?.addEventListener("click", (e) => {
      e.preventDefault();
      this.zoomOut();
    });
    reset?.addEventListener("click", (e) => {
      e.preventDefault();
      this.reset();
    });
  }

  zoomIn() {
    this.panzoom?.zoomIn();
  }

  zoomOut() {
    this.panzoom?.zoomOut();
  }

  reset() {
    if (!this.panzoom) return;
    this.panzoom.reset();
    this.updateScrollBehavior(1);
  }
}
